var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle",
    clipPath: "url(#clip0_0_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.73377 0.928138C4.65896 0.990267 4.60824 1.0766 4.59038 1.17219L4.15243 3.48821C4.12133 3.65287 4.04131 3.80433 3.92282 3.92282C3.80433 4.04131 3.65287 4.12133 3.48821 4.15243L1.17219 4.59038C1.0766 4.60824 0.990267 4.65896 0.928138 4.73377C0.866009 4.80858 0.832 4.90276 0.832 5C0.832 5.09724 0.866009 5.19142 0.928138 5.26623C0.990267 5.34104 1.0766 5.39176 1.17219 5.40962L3.48821 5.84757C3.65287 5.87867 3.80433 5.95869 3.92282 6.07718C4.04131 6.19567 4.12133 6.34713 4.15243 6.51179L4.59038 8.82781C4.60824 8.9234 4.65896 9.00973 4.73377 9.07186C4.80858 9.13399 4.90276 9.168 5 9.168C5.09724 9.168 5.19142 9.13399 5.26623 9.07186C5.34104 9.00973 5.39176 8.9234 5.40962 8.82781L5.84757 6.51179C5.87867 6.34713 5.95869 6.19567 6.07718 6.07718C6.19567 5.95869 6.34713 5.87867 6.51179 5.84757L8.82781 5.40962C8.9234 5.39176 9.00973 5.34104 9.07186 5.26623C9.13399 5.19142 9.168 5.09724 9.168 5C9.168 4.90276 9.13399 4.80858 9.07186 4.73377C9.00973 4.65896 8.9234 4.60824 8.82781 4.59038L6.51179 4.15243C6.34713 4.12133 6.19567 4.04131 6.07718 3.92282C5.95869 3.80433 5.87867 3.65287 5.84757 3.48821L5.40962 1.17219C5.39176 1.0766 5.34104 0.990267 5.26623 0.928138C5.19142 0.866009 5.09724 0.832 5 0.832C4.90276 0.832 4.80858 0.866009 4.73377 0.928138Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle3);
export default __webpack_public_path__ + "static/media/sparkle-3.d0c26f7d3adf2eb63e9bfffdd4f1f599.svg";
export { ForwardRef as ReactComponent };